import React from "react";
import { ScrollView } from "react-native";

export default function KeyboardAwareContainer(props) {
 return <ScrollView {...props} />;
}